<template>
  <div>
    <i-dropdown>
      <template v-slot:trigger="{toggle, attrs}">
        <button
          @click="toggle"
          class="i-button i-secondary-btn i-button-square"
          :aria-label="LANG.moreOptionsLabel"
          :title="LANG.moreOptionsLabel"
          v-bind="attrs">
            <i class="fa5 fas fa-ellipsis-h"></i>
            <span class="sr-only">{{LANG.moreOptionsLabel}}</span>
        </button>
      </template>

      <template v-slot:default="{close}">
        <ul
          class="dropdown-menu i-dropdown-menu block pull-right"
          style="margin-top: 2px;"
          role="menu"
        >
          <li :aria-label="LANG.saveFilter">
              <a href="#"
                @click.prevent="() => { showModal = true; close(); }"
                @keydown.enter.stop.prevent = "() => { showModal = true; close(); }"
                tabindex="0"
                :title="LANG.saveFilter">
                <i aria-hidden="true" class="fa5 fas fa-save" name="save"></i>
                <span class="pl1">{{ LANG.saveFilter }}</span>
              </a>
          </li>
          <li v-if="filterMode === FilterMode.ADVANCED" :aria-label="LANG.basicMode">
              <a href="#"
                @click.prevent="() => { setFilterMode({ mode: FilterMode.BASIC, isQueryDirty }); close(); }"
                @keydown.enter.stop.prevent="() => { setFilterMode({ mode: FilterMode.BASIC, isQueryDirty }); close(); }"
                tabindex="0"
                :title="LANG.basicMode">
                <i aria-hidden="true" class="fa5 fas fa-exchange-alt" name="exchange-alt"></i>
                <span class="pl1">{{ LANG.basicMode }}</span>
              </a>
          </li>
          <li v-else :aria-label="LANG.advancedSearch">
              <a href="#"
                @click.prevent="() => { setFilterMode({ mode: FilterMode.ADVANCED, query: basicModeFilterQuery }); close(); }"
                @keydown.enter.stop.prevent="() => { setFilterMode({ mode: FilterMode.ADVANCED, query: basicModeFilterQuery }); close(); }"
                tabindex="0"
                :title="LANG.advancedSearch">
                <i aria-hidden="true" class="fa5 fas fa-code" name="code"></i>
                <span class="pl1">{{ LANG.advancedSearch }}</span>
              </a>
          </li>
        </ul>
      </template>
    </i-dropdown>
    <FilterModalSave v-model:show="showModal"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mapBrowserState, mapBrowserMutations, mapBrowserGetters } from '@/store';
import { FilterMode } from '@/store/modules/entity_browser/config';
import FilterModalSave from './FilterModalSave.vue';

export default {
  components: {
    FilterModalSave,
  },
  data() {
    return {
      FilterMode,
      showModal: false,
    };
  },
  computed: {
    ...mapState(['LANG']),
    ...mapBrowserState([
      'filterMode',
      'advancedModeFilterQuery',
    ]),
    ...mapBrowserGetters([
      'basicModeFilterQuery',
    ]),
    isQueryDirty() {
      return this.advancedModeFilterQuery !== this.basicModeFilterQuery;
    },
  },
  methods: {
    ...mapBrowserMutations([
      'setFilterMode',
    ]),
  },
};
</script>

<style scoped lang='scss'>
  .i-button-square {
    width: 32px;
    height: 32px;
    font-size: 16px;
    padding: 0;
    margin: 0;
    i.fa5 {
      margin: 0;
    }
  }
</style>
